import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApps } from '../../store/auth/auth.actions';
import { getOrganization } from '../../store/org/org.actions';
import { RootState } from '../../store/store';
import { EmailQ } from './components/EmailQ/EmailQ';
import { SalesForce } from './components/SalesForce/SalesForce';
import { Webhooks } from './components/Webhooks/Webhooks';

export const Apps: React.FC = (): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);

  const { myOrg } = useSelector((state: RootState) => state.org);

  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      dispatch(getApps(user.orgId, user.userId));
      dispatch(getOrganization(user.orgId));
    }
  }, []); // eslint-disable-line

  const suggestFeatureClick = () => {
    window.open('https://feedback.substrata.me', '_blank');
  };

  return (
    <div className="apps">
      <EmailQ user={user} org={myOrg} />
      <Webhooks />
      <SalesForce user={user} />
      <div className="apps-suggest-feature" onClick={suggestFeatureClick}>
        Suggest a Feature
      </div>
    </div>
  );
};
